import React,{useEffect, useState} from 'react'
import Development from '../development-card'
import Loading from '../Loading'
import { connect } from 'react-redux'
import {getDevelopmentsFilterAction, updateFiltersDevelopment} from '../../redux/developmentsDucks'
import { getReverseOrder, getTitle, getOrderByDate } from '../../helpers/helper.developments'

const Developments = ({developmentsFilters,developments,loading,api_key,tag,dispatch}) => {

    // const [filter,setFilter] = useState(0)
    // const [buttons,setButtos] = useState([
    //     {
    //         name:"VER TODOS",
    //         value:0,
    //     },
    //     {
    //         name:"EN POZO",
    //         value:3,
    //     },
    //     {
    //         name:"EN CONSTRUCCIÓN",
    //         value:4
    //     },
    //     {
    //         name:"TERMINADOS",
    //         value:6
    //     }

    // ])

    useEffect(() => {
        if(api_key){	
            // dispatch(updateFiltersDevelopment(filter))
            dispatch(getDevelopmentsFilterAction()) // Get all developments
        }
    },[api_key])

    // const checkStatusInArray = (id) => {
    //     if(developments?.data?.objects.find(element => element.construction_status === id)){
    //         return true
    //     }
    //     return false;
    // }

    //Function to check if this page has a tag
    const checkTag = (developments) => {
        if(tag){
            return developments.filter(element => element.custom_tags.find(c_tag => c_tag.name.replaceAll(" ","-").toLowerCase() === tag) && !element.custom_tags.find(tag => tag.name.toLowerCase() === 'portada'))
        }
        return developments.filter(element => !element.custom_tags.find(tag => tag.name.toLowerCase() === 'portada'))
    }

     // State to get main dev by tag and show title
     const [development, setDevelopment] = useState();
     // Search on cached devs and set state
     useEffect(() => {
         if(developments){
             setDevelopment(getDevelopmentByTag())
         }
     },[developments, tag])
     // Helper to filter devs by tag
     const getDevelopmentByTag = () => {
         const developmentsSearch = []
         for (const dev of developments) {
             if(dev.custom_tags.find(element => element.name.toLowerCase().replaceAll(" ","-") === tag?.toLowerCase().replaceAll(" ","-"))){
                 developmentsSearch.push(dev)
             }
         }
         return developmentsSearch.find(element => element.custom_tags.find(atag => atag.name.toLowerCase() === 'portada'))
     }

    return  (
        <section id="featured-devs">
            {/* <div className={"container-fluid my-5 pb-lg-3 " + (developments?.data?.objects.length > 1 ? 'd-block' : "d-none")}>
                <div className={"d-flex flex-wrap justify-content-center " }>
                    {buttons.map((button,index) => (
                        (checkStatusInArray(button.value) || (button.value === 0 && developments?.data?.objects.length > 1)) &&
                        <button className={'button-filter mb-2 mb-lg-0 ' + (filter === button.value ? ' active ' : '')} onClick={() => setFilter(button.value)}>{button.name}</button>
                    ))}
                </div>
            </div> */}
            {
            developmentsFilters.data && !loading ?
                <div class="container-fluid dev-filter-container">
                    {getTitle(development)?.length > 0 
                        ? <h4 class="mb-5 text-uppercase">{getTitle(development)}</h4> : null}
                    <div class="row no-gutters mt-5 mt-lg-1 mb-lg-4" >
                        {
                            checkTag(getOrderByDate(developmentsFilters.data.objects)).length > 0 
                                ?   checkTag(getOrderByDate(developmentsFilters.data.objects)).map((development,index) => (
                                        <div class={index + " mb-3 mb-lg-4 pb-lg-2 px-lg-3 " + 
                                            (checkTag(developmentsFilters.data.objects).length === 1 
                                            ? 'col-lg-12 ' //Si es uno solo, 100%
                                            : ((checkTag(developmentsFilters.data.objects).length < 9 && index === 0 && checkTag(developmentsFilters.data.objects).length % 2 === 1)  
                                                ? 'col-lg-12 ' // Si impares menor a 9, el primero 100%
                                                : (checkTag(developmentsFilters.data.objects).length < 9) 
                                                    ? 'col-lg-6' //Si menores a 9, 50%
                                                    :  (checkTag(developmentsFilters.data.objects).length >= 9 && checkTag(developmentsFilters.data.objects).length % 3 === 1 && index === 0)
                                                        ? 'col-lg-12' // Si es mayor o igual a 9, y sobra 1, 100% el primero
                                                        : (checkTag(developmentsFilters.data.objects).length >= 9 && checkTag(developmentsFilters.data.objects).length % 3 === 2 && (index === 0 || index === 1)
                                                            ? 'col-lg-6' // Si son 9 o mas, y sobran 2, los primeros 2, 50%  
                                                            : 'col-lg-4' // Si son 9 o mas, 33,3%
                                            )))}>
                                            <Development key={index} development={development} tag={tag}/>
                                        </div>                  
                                    ))
                                :   <h4 className="text-center">No hay emprendimientos 
                                {/* {filter !== 0 && buttons.find(element => element.value === filter).name?.toLowerCase()} */}
                                </h4>
                        }
                    </div>
                </div>
            :<Loading />
            }
        </section> 
    )
}
export default connect(state => ({
    developmentsFilters: state.developments.developmentsFilters,
    loading: state.developments.loading,
    developments: state.developments.developments?.data?.objects,
    api_key: state.settings.keys.tokko

}),null)(Developments);